module.exports = __webpack_public_path__ + "static/media/light-source-behind.3863ffb8.gif";